import { useState, useEffect } from 'react';
import Axios from '../utils/axiosInstance';

const useProductDetail = (productId) => {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}collection/products/?id=${productId}`);
        setProduct(response.data.Products[0]);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  return { product, loading, error };
};

export default useProductDetail;
